import "../styles/home.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import event from "../images/bio3.webp";
import land from "../images/land.webp";
import { useState, useEffect } from "react";
import moment from "moment";
import MonthlyForm from "./MonthlyForm";

export default function Home() {
  const navigate = useNavigate();
  const startDate = "2025/01/31 23:59:59";
  const today = moment();
  const [showCount, setShowCount] = useState(true);
  const [countDown, setCountDown] = useState({});
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (today.diff(moment(startDate), "seconds") > 0) {
      setShowCount(false);
      setDisabled(true);
    }
    setTimeout(() => {
      calculateTimeLeft();
    }, 1000);
  }, [showCount, today]);

  const calculateTimeLeft = () => {
    let event = new Date(startDate).getTime();
    let now = new Date().getTime();

    let distance = event - now;

    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    setCountDown({ days: days, hours: hours, mins: minutes, secs: seconds });
  };

  const scrollTo = () => {
    document.getElementById("event").scrollIntoView();
  };

  return (
    <main className="home__main">
      {showCount ? (
        <section className="count__down">
          <p>Time Left To Claim This Offer:</p>
          <p className="count nums">
            <span>{countDown.days}</span> <span>{countDown.hours}</span>
            <span>{countDown.mins}</span> <span>{countDown.secs}</span>
          </p>
          <p className="count">
            <span>DAYS</span> <span>HOURS</span> <span>MINS</span>{" "}
            <span>SECS</span>
          </p>
        </section>
      ) : null}
      <section className="top__banner">
        <h1>Your All-in-One Path to Accelerating Your Results in 2025</h1>
      </section>
      <section className="hero">
        <h2>PMW Property Fast Track Package</h2>
        <p>
          Ready to kickstart your property investment journey in 2025?
          <br />
          The PMW Property Fast Track Package gives you everything you need to
          master key skills, raising finance and negotiation.
        </p>
      </section>
      <section className="bullet__section">
        <h2>What’s Included in the Fast Track Bundle?</h2>
        <section className="bullet__cols--hold">
          <section className="bullet__cols">
            <h3>
              Raising Finance Workshop
              <br />
              <span className="event__length">(2-Day Event)</span>
            </h3>
            <p className="bullet__col--text">
              Master the strategies to secure funding for your property deals,
              including private investments, joint ventures, and alternative
              finance options.
            </p>
            <p className="bullet__col--text">
              <span>
                This in-depth workshop is essential for anyone looking to:
              </span>
            </p>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Understand the Art of Raising Finance: </span>Learn how to
                confidently approach and secure funding for your deals.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Structure Your Deals: </span>Gain clarity on creating
                win-win structures that appeal to investors.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Safeguard Yourself When Investments: </span>Protect your
                interests when you are making investment with others.
              </p>
            </article>
            <p className="bullet__col--text">
              Delivered over two intensive days by <span>Paul McFadden</span>,
              this workshop will build your confidence and provide a deep
              understanding of all aspects of raising finance and structuring
              deals.
            </p>
            <h4>£2,000 + VAT</h4>
          </section>
          <section className="bullet__cols">
            <h3>
              Negotiation Workshop <br />
              <span className="event__length">(2-Day Event)</span>
            </h3>
            <p className="bullet__col--text">
              Take your negotiation skills to the next level to secure better
              deals and maximise profits. Learn to confidently handle sellers,
              agents, and contractors like a pro.
            </p>
            <p className="bullet__col--text">
              <span>This in-depth workshop includes:</span>
            </p>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Hands-On Role Play: </span>Practice negotiation techniques
                in a safe and supportive environment.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Proven Strategies: </span>Master the art of securing great
                deals and favourable terms that work to your advantage.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Confidence Building: </span>Leave equipped to approach any
                negotiation with clarity and assurance.
              </p>
            </article>
            <p className="bullet__col--text">
              These skills have the power to transform your property journey and
              unlock new opportunities for success. Mastering the art of
              communication will not only elevate your property deals but also
              enhance every area of your life!
            </p>
            <h4>£997 + VAT</h4>
          </section>
          <section className="bullet__cols">
            <h3>
              Tax Strategy & Planning Workshop <br />
              <span className="event__length">(1-Day Event)</span>
            </h3>
            <p className="bullet__col--text">
              Discover the exact tax planning strategies Paul personally uses to
              protect and grow his wealth while staying compliant. This is ideal
              for investors looking to save money and plan for long-term
              success.
            </p>
            <h4>£797 + VAT</h4>
          </section>
          <section className="bullet__cols">
            <h3>
              One-to-One Coaching Session <br />
              with Paul <em>Limited to the First 10 Buyers</em>
            </h3>
            <p className="bullet__col--text">
              Get personalised advice and actionable insights directly from Paul
              during a 60-minute Zoom call.
            </p>
            <h4>£2500 + VAT</h4>
          </section>
        </section>
        <h3>
          All for just <span>£1,497 + VAT</span>
        </h3>
        <h4>
          <em>When Purchased Before 31st Of January 2025</em>
        </h4>
        <button className="cta--btn" onClick={scrollTo}>
          Enrol NOW
        </button>
      </section>
      <section className="why__sect" style={{ backgroundColor: "#E6EDF7" }}>
        <h2>
          Land & New Build Development Workshop <br />
          <span>(2.5-Day Event)</span>
        </h2>
        <h3 className="land__price">ONLY £1,997 + VAT</h3>
        <p className="bundle__text">
          Take a deep dive into land and new build developments. Learn to
          identify opportunities, analyse deals, and navigate the development
          process from start to finish. Includes a site visit to Paul’s current
          active developments.
        </p>
      </section>
      <section className="why__sect">
        <h2>Bundle Package Deal</h2>
        <p className="bundle__text">
          Get access to all workshops, including the land and new build
          development training, for just <span>£2,997 + VAT</span>, saving a
          further <span>£1,000!</span>
        </p>
      </section>
      <section className="why__sect" style={{ backgroundColor: "#E6EDF7" }}>
        <h2>The Outcome: Master the Property Game</h2>
        <section className="img__row">
          <img src={event} alt="Paul In An Event" />
          <section className="text__side__row">
            <h3>This package is designed to:</h3>

            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Build Confidence: </span>Master the skills needed to raise
                finance, negotiate deals, and manage tax planning like an
                expert.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Expand Your Knowledge: </span>Learn advanced topics like
                land development and new builds.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Accelerate Your Growth: </span>Gain actionable strategies
                to fast-track your property success.
              </p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                <span>Receive Expert Guidance: </span>Get tailored advice
                directly from Paul McFadden to achieve your goals.
              </p>
            </article>
          </section>
        </section>
        <p className="why__text">
          By the end of this package, you’ll be fully equipped to raise capital,
          negotiate deals, optimise your tax strategy, and confidently explore
          new development opportunities.
        </p>
        <p className="why__text">
          <strong>
            Paul’s tax strategies alone could save you tens of thousands—if not
            hundreds of thousands— of pounds over the next 10 years!
          </strong>
        </p>
        <button className="cta--btn" onClick={scrollTo}>
          Enrol NOW
        </button>
      </section>
      <section className="why__sect">
        <h2>Exceptional Value for Serious Investors</h2>
        <section className="img__row">
          <section className="text__side__row">
            <h3 className="head__bg">Fast Track Package (£1,497 + VAT):</h3>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>Raising Finance Workshop: Included</p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>Negotiation Workshop: Included</p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>Tax Strategy & Planning Workshop: Included</p>
            </article>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>One-to-One Coaching Session with Paul</p>
            </article>
            <h3 className="head__bg">
              Land & New Build Development (£1,997 + VAT):
            </h3>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>Land & New Build Development Workshop</p>
            </article>
            <h3 className="head__bg">Bundle Offer (£2,997 + VAT):</h3>
            <article className="bullet__row">
              <CheckCircleIcon className="bullet--icon" />
              <p>
                Save over <span>£1,000</span> by bundling all workshops
                together!
              </p>
            </article>
          </section>
          <img src={land} alt="Acre Road Aereal Image" className="acre__road" />
        </section>
      </section>
      <section className="why__sect" style={{ backgroundColor: "#E6EDF7" }}>
        <h2 style={{ marginTop: 0 }}>
          Why Choose the PMW Property Fast Track Package?
        </h2>
        <p className="end__text">
          This isn’t just another training package. It’s a focused,
          results-driven program centred around the two most critical skills for
          property success: raising finance and negotiation. Mastering these
          will deliver a <span>significant ROI</span> on your investment into
          the workshops.
        </p>
        <h3 className="offer">Offer Open Until Midnight, 31st January</h3>
        <p className="end__text">
          Spaces are limited, and coaching sessions with Paul are available for
          the <span>first 10 buyers only</span>. Don’t wait—secure your spot
          today and take advantage of the bundle package offer!
        </p>
      </section>
      <section className="event" id="event">
        {/* <h2>Bundle Package Deal</h2> */}
        <aside className="payment--box">
          <h4>Fast Track Bundle & Land Development</h4>
          <h3>Now For...</h3>
          <h2 className="blur value">
            £2,997 <span>+ VAT</span>
          </h2>
          <small>*Best Value Deal*</small>
          <button
            onClick={() => navigate("/register?prod=bundle")}
            disabled={disabled}
          >
            Sold Out
          </button>
        </aside>
        <aside className="payment--box">
          <h4>Fast Track Bundle Only</h4>
          <h3>Now For...</h3>
          {/* TODO: Change price */}
          <h2 className="blur">
            £1,497 <span>+ VAT</span>
          </h2>
          <button
            onClick={() => navigate("/register?prod=fast-track")}
            disabled={disabled}
          >
            Sold Out
          </button>
        </aside>
        <aside className="payment--box">
          <h4>Land Development Course Only</h4>
          <h3>Now For...</h3>
          <h2 className="blur">
            £1,997 <span>+ VAT</span>
          </h2>
          <button
            onClick={() => navigate("/register?prod=land-development")}
            disabled={disabled}
          >
            Sold Out
          </button>
        </aside>
      </section>
      <MonthlyForm />
    </main>
  );
}
